import { createAsyncThunk } from "@reduxjs/toolkit";
import viewTrackingService from "../../../api/services/viewTracking";

export const trackBandView = createAsyncThunk(
  "viewTracking/track-band-view",
  async (bandId) => {
    return await viewTrackingService.trackBandView(bandId);
  }
);

export const getBandViewStats = createAsyncThunk(
  "viewTracking/get-band-view-stats",
  async (bandId) => {
    return await viewTrackingService.getBandViewStats(bandId);
  }
);

export const getMostViewedBands = createAsyncThunk(
  "viewTracking/get-most-viewed-bands",
  async ({ limit, days } = {}) => {
    return await viewTrackingService.getMostViewedBands({ limit, days });
  }
);